module.exports = __webpack_public_path__ + "img/teamImg7.82606428.jpg";